/**
 * Inline link to the Polomar Specialty Pharmacy bio on /pharmacy-info.
 *
 * Every visible mention of the pharmacy name in the patient-facing UI
 * should use this so patients can jump to the official bio (license #,
 * COA samples, contact) in one tap. Hash-fragment lands on Polomar's
 * specific section when there are multiple pharmacies in the future.
 */
import { Link } from "react-router-dom";

export default function PharmacyLink({ children, className = "", testId = "pharmacy-link", target }) {
  return (
    <Link
      to="/pharmacy-info#polomar"
      target={target}
      rel={target === "_blank" ? "noreferrer" : undefined}
      className={`text-purple-700 dark:text-purple-300 hover:text-purple-900 dark:hover:text-purple-200 underline underline-offset-2 decoration-purple-300 hover:decoration-purple-600 ${className}`}
      data-testid={testId}
    >
      {children || "Polomar Specialty Pharmacy"}
    </Link>
  );
}
